import { render } from "./waitPurchaseList.vue?vue&type=template&id=5aaf2aa1&scoped=true&ts=true"
import script from "./waitPurchaseList.vue?vue&type=script&lang=ts"
export * from "./waitPurchaseList.vue?vue&type=script&lang=ts"

import "./waitPurchaseList.vue?vue&type=style&index=0&id=5aaf2aa1&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aaf2aa1"]])

export default __exports__